/* eslint-disable */

import { useSelector } from "react-redux";
import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import {
  DARK_MODE_CHART_1,
  LIGHT_MODE_CHART_1,
  NEW_AXIS_TICK,
  NEW_BOTH_FEET_COLOR,
  NEW_RIGHT_COLOR,
} from "utils/constant";

const CustomTooltip = ({ active, payload, label, data }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    
    return (
      <div className="custom-tooltip-overview">
        <div className="label">{data.activity}</div>
        <div className="sub-label athlete-label">
          {/*  ---------------------------------  */}

          {payload[0] ? (
            <div>
              <p style={{ color: payload[0].stroke }}>
                {payload[0].name}: {data.athleteTotal?.toFixed(2)} {data.unit}
              </p>
            </div>
          ) : null}

          {payload[1] ? (
            <div>
              <p style={{ color: payload[1].stroke }}>
                {payload[1].name}: {data.athleteTotalAvg?.toFixed(2)}{" "}
                {data.unit}
              </p>
            </div>
          ) : null}

          {payload[2] ? (
            <div>
              <p style={{ color: payload[2].stroke }}>
                {payload[2].name}: {data.athleteTotalMin?.toFixed(2)}{" "}
                {data.unit}
              </p>
            </div>
          ) : null}
          {payload[3] ? (
            <div>
              <p style={{ color: payload[3].stroke }}>
                {payload[3].name}: {data.athleteTotalMax?.toFixed(2)}{" "}
                {data.unit}
              </p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
};

const OverivewRadarChart = (props) => {
  const { radarChartData } = props;

  const mode = useSelector(state => state.theme.mode)


  return (
    <ResponsiveContainer width="100%">
      <RadarChart outerRadius={110} data={radarChartData}>
        <PolarGrid stroke={mode == "dark" ? DARK_MODE_CHART_1 : LIGHT_MODE_CHART_1} strokeWidth={1} opacity={0.4} />
        <PolarAngleAxis dataKey="subject" />
        <PolarRadiusAxis
          angle={90}
          orientation="middle"
          domain={[-5, 5]}
          fontSize={8}
          label={{
            position: "bottom",
            fill: mode == "dark" ? DARK_MODE_CHART_1 : LIGHT_MODE_CHART_1,
            offset: 50,
          }}
          axisLine={false}
          tick={false}
        />
        <Legend wrapperStyle={{fontSize: "9px"}}/>

        <Radar
          name="Selected Section"
          dataKey="athleteTotalValue"
          fill={NEW_RIGHT_COLOR}
          stroke={"rgba(52, 152, 219,1.0)"}
          fillOpacity={0.4}
          strokeWidth={1}
          legendType="rect"
        />

        <Radar
          name="All Time Avg"
          dataKey="athleteZscore"
          fill={"none"}
          stroke={"rgba(241, 196, 15,1.0)"}
          strokeWidth={1}
          strokeDasharray="10 5"
          legendType="square"
        />
        <Radar
          name="All Time Min"
          dataKey="athleteTotalMinValue"
          fill={"none"}
          stroke={"rgba(231, 76, 60,1.0)"}
          strokeWidth={1}
          strokeDasharray="10 5"
          legendType="square"
        />
        <Radar
          name="All Time Max"
          dataKey="athleteTotalMaxValue"
          fill={"none"}
          stroke={"rgba(46, 204, 113,1.0)"}
          strokeWidth={1}
          strokeDasharray="10 5"
          legendType="square"
        />
        <Tooltip content={<CustomTooltip data={radarChartData} />} />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default OverivewRadarChart;
